import { bus } from "@/main.js";

export default {
	name: "App",
	data() {
		return {
			hideContent: false,
			url: null,
		}
	},
	created() {
		this.getContent();
	},
	mounted() {
	},
	computed: {
		getCurrentUrl: function() {
			return location.href;
		}
	},
	watch: {
		"$route": function() {
			this.getContent();
		}
	},
	methods: {
		getContent() {
		},
		evalRoute(value) {
			if (value == this.$route.path)
				return true
			else
				return false
		},
	},
}



// WEBPACK FOOTER //
// ./src/App.js